import { IChat, IChatsRecord } from '../../interfaces/chats';

export const mergeApiEventsWithLocalPreviews = (
  apiEvents: IChatsRecord[],
  localEvents: IChatsRecord[],
  previousApiEvents: IChatsRecord[] = [],
  liveFirst = true
): IChatsRecord[] => {
  if (!localEvents.length) return apiEvents;

  const localByChatId = new Map<string, IChat>();
  const localEventIndex = new Map<string, number>();
  localEvents.forEach((event, index) => {
    localEventIndex.set(event.eventId, index);
    for (const chat of event.chats) {
      localByChatId.set(chat.id, chat);
    }
  });

  const previousByChatId = new Map<string, IChat>();
  for (const event of previousApiEvents) {
    for (const chat of event.chats) {
      previousByChatId.set(chat.id, chat);
    }
  }

  const liveEventIds = new Set<string>();
  const merged = apiEvents.map((event) => ({
    ...event,
    chats: event.chats.map((chat) => {
      const local = localByChatId.get(chat.id);
      if (!local || (local.lastMessageId ?? 0) <= (chat.lastMessageId ?? 0)) return chat;

      liveEventIds.add(event.eventId);
      const previous = previousByChatId.get(chat.id);
      return {
        ...chat,
        lastMessage: local.lastMessage,
        lastMessageTime: local.lastMessageTime,
        lastMessageAt: local.lastMessageAt,
        lastMessageId: local.lastMessageId,
        unreadMessageCount:
          previous && previous.unreadMessageCount !== chat.unreadMessageCount
            ? chat.unreadMessageCount
            : local.unreadMessageCount,
        hasUnreadMention:
          previous && previous.hasUnreadMention !== chat.hasUnreadMention ? chat.hasUnreadMention : local.hasUnreadMention,
      };
    }),
  }));

  if (!liveFirst || !liveEventIds.size) return merged;

  const liveEvents = merged
    .filter((event) => liveEventIds.has(event.eventId))
    .sort((a, b) => (localEventIndex.get(a.eventId) ?? 0) - (localEventIndex.get(b.eventId) ?? 0));
  return [...liveEvents, ...merged.filter((event) => !liveEventIds.has(event.eventId))];
};

export const clearSelectedChatUnread = (events: IChatsRecord[], selectedChatId?: string): IChatsRecord[] => {
  if (!selectedChatId) return events;
  let changed = false;
  const next = events.map((event) => {
    if (!event.chats.some((chat) => chat.id === selectedChatId && (chat.unreadMessageCount || chat.hasUnreadMention))) {
      return event;
    }
    changed = true;
    return {
      ...event,
      chats: event.chats.map((chat) =>
        chat.id === selectedChatId ? { ...chat, unreadMessageCount: 0, hasUnreadMention: false } : chat
      ),
    };
  });
  return changed ? next : events;
};
